exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.botones-filtros button {\n  font-size: 11px;\n}\n", ""]);

// exports
